import { call, all, put, takeLatest } from "redux-saga/effects";
import { doGet, doPost, doPut } from "../utils/request";
import {
  getAllTaxInspectorSuccess,
  getAllTaxInspectorFail,
  addTaxInspectorSuccess,
  addTaxInspectorFail,
  getTIOfDistrictSuccess,
  getTIOfDistrictFail,
  updateTISuccess,
  updateTIFail,
} from "../actionCreators/TaxInspector";


function* getTIOfDistrict({ obj }) {
  try {
    const response = yield doGet(
      `/userti/getTisBydistrictId?districtId=${`${obj?.districtId}&search=${obj.search}`}`
    );
    yield put(getTIOfDistrictSuccess(response?.data));
  } catch (err) {
    yield put(
      getTIOfDistrictFail(err?.response?.data?.message || err?.message)
    );
    yield put(getTIOfDistrictFail());
  }
}

function* getAllTaxInspector({ obj }) {
  try {
    const response = yield doGet(
      `userti/getAllTis?page=${obj?.page}&pageSize=${obj?.pageSize
      }&userName=${[undefined, null, ""].includes(obj?.searchString)
        ? `""`
        : `"${obj?.searchString}"`
      }&filter=${obj?.filterBody}`
    );
    yield put(getAllTaxInspectorSuccess(response?.data));
  } catch (err) {
    yield put(getAllTaxInspectorFail(err?.response?.data?.message || err?.message));
    yield put(getAllTaxInspectorFail());
  }
}

function* addTaxInspector({ obj }) {
  try {
    const response = yield doPost(`/userti/addTi`, obj);
    yield put(addTaxInspectorSuccess(response?.data));
  } catch (err) {
    // yield put(addETOFail(err?.message));
    yield put(addTaxInspectorFail((err?.response?.data?.message ? err?.response?.data?.message : "Server Down")));
  }
}

function* updateTI({ obj }) {
  try {
    const response = yield doPut(
      `/userti/updateTi`
      , obj
    );
    yield put(updateTISuccess(response?.data));
  } catch (err) {
    yield put(
      updateTIFail(err?.response?.data?.message || err?.message)
    );
    yield put(updateTIFail());
  }
}




export default function* watcher() {
  yield all([
    takeLatest("GET_ALL_TAX_INSPECTOR", getAllTaxInspector),
    takeLatest("ADD_TAX_INSPECTOR", addTaxInspector),
    takeLatest("GET_TI_OF_DISTRICT", getTIOfDistrict),
    takeLatest("UPDATE_TI", updateTI),
  ]);
}
